import { type PriceProps } from '@debijenkorf/price';

import { createMapper } from '../dataMapper';

import type {
  OriginalPrice,
  PreviousLowestAndOriginalPrice,
  Pricing,
  RecommendedAndOriginalPrice,
  RecommendedPrice,
  SigningsV2,
} from '@/types/api/product';

type PriceDetailsVariants = {
  recommendedPrice?: Partial<RecommendedPrice>;
  originalPrice?: Partial<OriginalPrice>;
  previousLowestAndOriginalPrice?: Partial<PreviousLowestAndOriginalPrice>;
  recommendedAndOriginalPrice?: Partial<RecommendedAndOriginalPrice>;
};

export type PriceMapperInput = {
  price: Omit<Pricing, 'details'> & PriceDetailsVariants;
  signings?: SigningsV2;
};

export type PriceMapperProps = PriceProps;

export const priceMapper = createMapper<PriceMapperInput, PriceMapperProps>(
  ({ price, signings }) => {
    const original =
      price.originalPrice?.original ??
      price.previousLowestAndOriginalPrice?.original ??
      price.recommendedAndOriginalPrice?.original;
    const recommended =
      price.recommendedPrice?.recommended ?? price.recommendedAndOriginalPrice?.recommended;

    const isStrikethrough = Boolean(original?.strikeThrough);

    return {
      sellingPrice: price.value,
      recommendedPrice: recommended?.value,
      overriddenPrices: isStrikethrough && original ? [original.value] : [],
      lowestPrice: price.previousLowestAndOriginalPrice?.previousLowest?.value,
      originalPrice: !isStrikethrough ? original?.value : undefined,
      discountLabel: signings?.discount,
      label: price.label,
      isOnSale: Boolean(price.showPriceDiscounted),
    };
  },
);
